import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['report'] = {
    advertViews: 'Хабарландыруды қараулар',
    callRequest: 'Қоңырауға тапсырыс',
    loadError:   'Есеп деректерін алу кезінде қате шықты',
    newAuto:     'Жаңа көліктер',
    phoneViews:  'Телефонды қараулар',
    services:    {
        hot: '«Ыстық» бөліміне жіберілді',
        up:  '«ТОП»-қа жіберілді',
        vip: '«VIP»-ке қосылды',
    },
    top: 'Топ {place}',
};

export default kk;
